export const userRoles = {
    ROLE_ADMIN: "ROLE_ADMIN",
    ROLE_USER: "ROLE_USER",
    ROLE_INTERMEDIARY_ADMIN: "ROLE_INTERMEDIARY_ADMIN",
    ROLE_INTERMEDIARY_SUPPLY: "ROLE_INTERMEDIARY_SUPPLY",
    ROLE_INTERMEDIARY_DEMAND: "ROLE_INTERMEDIARY_DEMAND",
    ROLE_INTERMEDIARY_REPORT: "ROLE_INTERMEDIARY_REPORT",
    ROLE_INTERMEDIARY_BILLING: "ROLE_INTERMEDIARY_BILLING"
}


export const roles = [
    { label: 'ADMIN', value: 'ROLE_ADMIN' },
    { label: 'BILLING', value: 'ROLE_INTERMEDIARY_BILLING' },
    { label: 'SUPPLY', value: 'ROLE_INTERMEDIARY_SUPPLY' },
    { label: 'DEMAND', value: 'ROLE_INTERMEDIARY_DEMAND' },
    { label: 'REPORT', value: 'ROLE_INTERMEDIARY_REPORT' },
    {label: 'USER',value:'ROLE_USER'}
];
